var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.935 7.15108L10.0145 12.6502L1.73016 9.88835C1.1519 9.6952 0.762319 9.15266 0.765646 8.54314C0.769017 7.93362 1.16306 7.3944 1.74356 7.208L22.9239 0.387159C23.4273 0.225311 23.98 0.358134 24.354 0.73213C24.7279 1.10613 24.8608 1.65869 24.6989 2.16218L17.878 23.3425C17.6916 23.923 17.1524 24.317 16.5429 24.3204C15.9334 24.3237 15.3908 23.9341 15.1977 23.3559L12.4225 15.0314L17.935 7.15108Z",
    fill: "#E9A5F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentSend);
export default __webpack_public_path__ + "static/media/commentSend.ad345732b73f408bc72d31acaf36b3a7.svg";
export { ForwardRef as ReactComponent };